import { userAuditLogsQueryOptions } from "@/features/dashboard/api/queries/user-audit-logs-queries";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_dashboard/settings_/user-audit-logs")({
	validateSearch: z.object({
		search: z.string().optional(),
		user_id: z.string().optional(),
		action: z.string().optional(),
		per_page: z.number().optional(),
		page: z.number().nullable().optional(),
		date_from: z.string().optional(),
		date_to: z.string().optional(),
		sort_by: z.string().optional(),
		sort_order: z.enum(["asc", "desc"]).optional(),
	}),
	preSearchFilters: [
		(search) => ({
			...search,
		}),
	],
	loaderDeps: ({ search }) => ({
		page: search.page,
		per_page: search.per_page,
		search: search.search,
		user_id: search.user_id,
		action: search.action,
		date_from: search.date_from,
		date_to: search.date_to,
		sort_by: search.sort_by,
		sort_order: search.sort_order,
	}),
	loader: ({ context: { queryClient }, deps }) => {
		return queryClient.ensureQueryData(
			userAuditLogsQueryOptions({
				...deps,
			}),
		);
	},
	component: lazyRouteComponent(() => import("@/features/dashboard/pages/settings.user-audit-logs")),
});
